<template>
  <div class="user-management-container">
    <!-- RepairProductSearch-->
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="RepairProductSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>设备维修</div>
      </template>
      <template v-slot:tabelTitleRight>
        <!-- <control-button @buttonClick="openPrint">
          打印报价单
        </control-button> -->
      </template>
      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>
        <text-field labelText="品牌名称:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.BrandId"
              @change="handlePinP"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.pinP"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>

        <text-field labelText="产品类别:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.ProductId"
              clearable
              @change="handlechanPType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.chanPType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>

        <text-field labelText="产品型号:" class="condition-container-input">
          <template #default="">
            <el-select
              v-model="conditionData.ModelNoId"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options.chanPNum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
        </text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.staetime"
          type="date"
          labelText="申请起始日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.endtime"
          type="date"
          labelText="申请截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>
        <text-field
          v-model:value="conditionData.AssignName"
          labelText="请领人:"
          class="condition-container-input"
        >
        </text-field>
      </template>
      <template v-slot:repairBtn="$opData">
        <!-- <div class="opration">
					<control-button class="item"
						@buttonClick="customerRowDblClick($opData.data.row)">*</control-button>
				</div> -->
        <div class="opration el-iconBtn">
          <img
            src="../../public/static/images/repair.png"
            style="width: 20px; height: 20px"
            alt=""
            srcset=""
            @click="customerRowDblClick($opData.data.row)"
          />
          <!-- <i class="el-icon-check" @click="receiveBtn($opData.data.row, 0)"></i> -->
        </div>
      </template>
      <template v-slot:goBackBtn="$opData">
        <!-- <div class="opration">
					<del-button class="item"
						:useConfirm="true" comfirmMessage="确定返回吗？" 
						comfirmOkText="确定" comfirmCancelText="取消" 
						:icon="false"
						@buttonClick="delSingleUser($opData.data)">f</del-button>
				</div> -->
        <div class="opration el-iconBtn" @click="delSingleUser($opData.data)">
          <img
            src="../../public/static/images/cancel.png"
            style="width: 20px; height: 20px"
            alt=""
            srcset=""
          />
        </div>
      </template>
    </tabel-panel>

    <pop-dialog
      id="loadBOX"
      v-if="loadShow"
      ref="getMenuList"
      detailShowType="data"
      :drag="false"
      @dialogClose="loadShow = false"
    >
      <div class="oprationTree">
        <div class="detailed-box">
          <div class="detailed-title">设备维修编辑信息</div>
          <el-tabs v-model="activeName" type="card" style="height: 50%">
            <el-tab-pane label="检测信息" :disabled="tabs.second" name="second">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="RMA:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompName"
                  labelText="客户名称:"
                  :readOnly="true"
                  type="text"
                  :placeholder="null"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.LinkMan"
                  labelText="联系人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="电话:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompCode"
                  labelText="手机:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="电话:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompCode"
                  labelText="手机:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.BrandName"
                  labelText="品牌:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AttachName"
                  labelText="配件:"
                  :readOnly="true"
                  placeholder=" "
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusApp"
                  labelText="症状信息:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.NotExpressName"
                  labelText="递送方式:"
                  :readOnly="true"
                  placeholder=" "
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.sendOdd"
                  labelText="客户邮寄单号:"
                  :readOnly="true"
                  placeholder=" "
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.sendTime"
                  labelText="寄出时间:"
                  :readOnly="true"
                  placeholder=" "
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.sendServe"
                  labelText="维修中心:"
                  :readOnly="true"
                  placeholder=" "
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.Appendix"
                  labelText="备注:"
                  placeholder=" "
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="SN:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>

                <text-field
                  v-model:value="rowData.AssignName"
                  labelText="请领人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AssignDate"
                  labelText="请领日期:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.AssignName"
                  labelText="检测人:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectDate"
                  labelText="检测日期:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.DetectDesc"
                  labelText="实际检测结果:"
                  :readOnly="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
              </div>
            </el-tab-pane>
            <el-tab-pane label="报价信息" :disabled="tabs.first" name="first">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="合同:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.WeiBaoName"
                  labelText="维保服务:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Level_Id"
                  labelText="维修级别:"
                  :requird="true"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="LevelSearchs"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value.number="rowData.App1"
                  labelText="快递邮资:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value.number="rowData.App3"
                  labelText="工时:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value.number="rowData.App2"
                  labelText="折扣:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value.number="rowData.App4"
                  labelText="总计:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value.number="rowData.CusPrice"
                  labelText="给客户报价:"
                  :requird="requirdCusPrice"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusPriceMethod_Id"
                  labelText="客户报价方式:"
                  :requird="requirdCusPriceMethod"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="CusPriceType"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CusPayMethod_Id"
                  labelText="客户付款方式:"
                  :requird="requirdCusPriceMethod"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="CusPayType"
                  class="condition-container-input"
                >
                </text-field>

                <div
                  class="checkbox-box"
                  style="width: 220px; margin-left: 25px"
                >
                  <label for="checkbox1">是否在保修期内: </label>
                  <input
                    type="checkbox"
                    v-model="rowData.IsWarranty"
                    name=""
                    id="checkbox1"
                  />
                </div>
                <div
                  class="checkbox-box"
                  style="width: 220px; margin-left: 25px"
                >
                  <label for="checkbox2">是否同意报价: </label>
                  <input
                    type="checkbox"
                    v-model="rowData.IsAgreePrice"
                    name=""
                    id="checkbox2"
                  />
                </div>
                <div
                  class="checkbox-box"
                  style="width: 220px; margin-left: 25px"
                >
                  <label for="checkbox3">是否放弃维修: </label>
                  <input
                    type="checkbox"
                    v-model="rowData.IsGiveUp"
                    name=""
                    id="checkbox3"
                  />
                </div>
              </div>
              <div>
                <control-button @buttonClick="saveBtn"> 保存 </control-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="维修" :disabled="tabs.three" name="three">
              <div>
                <text-field
                  v-model:value="rowData.NewSN"
                  labelText="新序列号:"
                  :clearable="true"
                  type="text"
                  class="tabsThree-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.InternalRepairMethod"
                  labelText="维修方法:"
                  :requird="true"
                  :clearable="true"
                  type="textarea"
                  class="tabsThree-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Appendix"
                  labelText="备注:"
                  :clearable="true"
                  type="textarea"
                  class="tabsThree-input"
                >
                </text-field>
              </div>
              <div>
                <control-button @buttonClick="repairSaveBtn">
                  保存
                </control-button>
              </div>
            </el-tab-pane>

            <el-tab-pane label="返厂维修" :disabled="tabs.fourth" name="fourth">
              <div style="display: flex; flex-wrap: wrap">
                <text-field
                  v-model:value="rowData.RMANo"
                  labelText="RMA:"
                  :requird="true"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.CompName"
                  labelText="客户名称:"
                  :placeholder="null"
                  :readOnly="true"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.SerialNoName"
                  labelText="SN:"
                  :readOnly="true"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactoryBack_Id"
                  labelText="返厂名称:"
                  :requird="true"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="BackFactory"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.LinkMan"
                  labelText="联系人:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Address"
                  labelText="地址:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TelNo"
                  labelText="联系电话:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.Email"
                  labelText="Email:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FaxNo"
                  labelText="传真:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.PostNo"
                  labelText="邮编:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactoryPrice"
                  labelText="厂家报价:"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.MotoRMA"
                  labelText="返厂RMA:"
                  :requird="true"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TransferNo"
                  labelText="货运单号:"
                  :requird="true"
                  :clearable="true"
                  type="text"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.TranComp_Id"
                  labelText="货运公司:"
                  :requird="true"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="selectDataComp"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.ReFacDate"
                  labelText="寄送时间:"
                  :requird="true"
                  :clearable="true"
                  type="date"
                  class="condition-container-input"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FacRetDate"
                  labelText="返回时间:"
                  :clearable="true"
                  type="date"
                  class="condition-container-input"
                  style="height: 24px"
                >
                </text-field>
                <text-field
                  v-model:value="rowData.FactRepairMethod"
                  labelText="厂家维修方法:"
                  :clearable="true"
                  type="textarea"
                  class="condition-container-input"
                  style="width: 480px"
                >
                </text-field>
                <div class="checkbox-box">
                  <label for="checkbox4">厂家是否返回: </label>
                  <input
                    type="checkbox"
                    v-model="rowData.IsFactInvoice"
                    name=""
                    id="checkbox4"
                  />
                </div>
              </div>
              <div>
                <control-button @buttonClick="returnRepairSaveBtn">
                  保存
                </control-button>
              </div>
            </el-tab-pane>
          </el-tabs>
          <el-row style="height: 300px">
            <el-col :span="24">
              <tabel-panel
                ref="tabelSNlist"
                style="height: 270px"
                :rowTemplate="tableCustomer"
                api="RepairComplateSearch"
                :condition="CustomerList"
                editType="pop"
                :showCondition="false"
                :autoSearch="true"
                :showCancelButton="false"
                :clickRowSelected="false"
                :popToCustomer="true"
              >
                <template v-slot:tabelTitleLeft>
                  <div style="padding-left: 10px">维修详细信息</div>
                </template>
                <template v-slot:goBackBtn="$opData">
                  <div class="opration">
                    <update-button
                      class="item"
                      @buttonClick="editTabelSN($opData.data.row)"
                    >
                    </update-button>
                  </div>
                </template>
              </tabel-panel>
            </el-col>
          </el-row>
          <div class="pop-dialogClose" @click="handDialogClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </pop-dialog>
    <pop-dialog
      id="printBox"
      @confirmClick="popUploadClick"
      v-if="print"
      ref="get"
      :meta="popDialogList"
      detailShowType="data"
      @dialogClose="handDialogClose"
    >
      <div class="oprationTree">
        <div class="detailed-box">
          <div class="detailed-title">设备维修编辑信息</div>
          <div>bbbb</div>
          <div class="pop-dialogClose" @click="handDialogClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
    </pop-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import controlButton from "@/components/controlButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
  RepairProductCancel,
  MoneySave,
  BackFactorySave,
  RepairSave,
  AddRetRma,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";

export default {
  name: "RepairProduct",
  components: {
    textField,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
    controlButton,
  },
  data() {
    return {
      options: {
        pinP: [],
        chanPType: [],
        chanPNum: [],
      },
      conditionData: {
        compid: null,
        AssignName: null,

        BrandId: null,
        ProductId: null,
        ModelNoId: null,

        sn: null,
        staetime: null,
        endtime: null,
      },
      Iszxx: [],
      rowDataIsFactInvoice: [],
      activeName: "second",
      checked: false,
      resource: "",
      radio: null,
      inputValue: "明细",
      print: false,
      loadShow: false,
      rowData: null,
      //客户报价方式:
      requirdCusPriceMethod: false,
      requirdCusPrice: true,
      rowTemplate: [
        {
          columnType: "check",
          width: 130,
        },
        {
          headerLabel: "维修状态",
          width: 180,
          dataIndex: "State",
        },
        {
          headerLabel: "递送方式",
          sortable: true,
          dataIndex: "NotExpressName",
          width: 180,
        },
        {
          headerLabel: "产品",
          width: 200,
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          sortable: true,
          dataIndex: "ModelNoName",
          width: 200,
        },
        {
          headerLabel: "SN",
          sortable: true,
          width: 200,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1 ? "red" : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "症状信息",
          width: 200,
          dataIndex: "CusApp",
        },
        {
          headerLabel: "备注",

          dataIndex: "AttachName",
        },
        {
          headerLabel: "客户名称",
          width: 260,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "接收日期",
          width: 260,
          sortable: true,
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "请领人",
          dataIndex: "AssignName",
          width: 200,
        },
        {
          headerLabel: "维修周期",
          width: 200,
          sortable: true,
          dataIndex: "RepairCycle",
        },
        {
          headerLabel: "附件",
          width: 200,
          dataIndex: "AttachName",
        },
        {
          headerLabel: "实际检测结果", //0
          width: 200,
          dataIndex: "DetectDesc",
        },
        {
          headerLabel: "维修中心",
          width: 180,
          dataIndex: "ServerName",
        },
        {
          headerLabel: "维修",
          slot: "repairBtn",
          width: 200,
        },
        {
          headerLabel: "返回",
          slot: "goBackBtn",
          width: 200,
        },
      ],

      CusPriceSave: {
        Id: null, // id	Int	id	是
        IsWarranty: false, // IsWarranty	Bool	是否在保修范围内
        Level_Id: null, // level	Int	维修级别	是
        App1: 0, // App1	Decimal	邮费
        App2: 0, // App2	Decimal	折扣
        App3: 0, // App3	Int	工时
        App4: 0, // App4	Decimal	总计
        CusPrice: 0, // CusPrice	Decimal	客户报价	是
        CusPriceMethod: null, // CusPriceMethod	Int	客户报价方式
        CusPayMethod: null, // CusPayMethod	Int	客户付款方式
        IsAgreePrice: false, // IsAgreePrice	Bool	是否同意价格
        IsGiveUp: false, // IsGiveUp	Bool	是否放弃维修
      },
      CusPriceSaveR: {
        Id: null, // id	Int	id	是
        IsWarranty: false, // IsWarranty	Bool	是否在保修范围内
        Level_Id: null, // level	Int	维修级别	是
        App1: 0, // App1	Decimal	邮费
        App2: 0, // App2	Decimal	折扣
        App3: 0, // App3	Int	工时
        App4: 0, // App4	Decimal	总计
        CusPrice: 0, // CusPrice	Decimal	客户报价	是
        CusPriceMethod: null, // CusPriceMethod	Int	客户报价方式
        CusPayMethod: null, // CusPayMethod	Int	客户付款方式
        IsAgreePrice: false, // IsAgreePrice	Bool	是否同意价格
        IsGiveUp: false, // IsGiveUp	Bool	是否放弃维修
      },
      selectDataProCateName: [
        {
          label: "一级维修",
          value: 1,
        },
        {
          label: "二级维修",
          value: 2,
        },
        {
          label: "三级维修",
          value: 3,
        },
      ],
      selectCusPriceMethod: [
        {
          label: "电子邮件",
          value: 3040,
        },
        {
          label: "电话通知",
          value: 3041,
        },
        {
          label: "当面通知",
          value: 3043,
        },
        {
          label: "传真报价",
          value: 3042,
        },
      ],
      selectCusPayMethod: [
        {
          label: "现金",
          value: 3044,
        },
        {
          label: "支票",
          value: 3045,
        },
        {
          label: "转账",
          value: 3047,
        },
        {
          label: "记账",
          value: 3046,
        },
      ],
      tabs: {
        second: false,
        first: false,
        three: false,
        fourth: false,
      },
      tableCustomer: [
        {
          headerLabel: "接收日期",
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "实际检测结果",
          dataIndex: "DetectDesc",
        },
        {
          headerLabel: "维修方法",
          dataIndex: "FactRepairMethod",
        },
        {
          headerLabel: "附件",
          dataIndex: "AttachName",
        },
        {
          headerLabel: "维修中心",
          dataIndex: "ServerName",
        },
        {
          headerLabel: "请领人",
          dataIndex: "AssignName",
        },
        {
          headerLabel: "维修周期",
          dataIndex: "RepairCycle",
        },
        {
          headerLabel: "保修",
          dataIndex: "IsWarranty",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "返厂", //0
          dataIndex: "IsReturnFact",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "放弃",
          dataIndex: "IsGiveUp",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
      ],
      // 维修记录查询条件
      CustomerList: {
        flag: null,
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
        staetime: null,
        endtime: null,
        rma: null,
        isfact: null,
      },
      selectChildData: null,
      selectChildMoid: null,
    };
  },
  computed: {
    // rowData.IsWarranty
    // rowData.IsAgreePrice
    // rowData.IsGiveUp
  },
  watch: {
    "rowData.IsWarranty": function (newVal) {
      console.log("newVal", newVal);
      if (newVal === true) {
        this.requirdCusPriceMethod = false;
        this.rowData.IsAgreePrice = false;
        this.rowData.IsGiveUp = false;
      }
      this.requirdCusPriceTrue();
    },
    "rowData.IsAgreePrice": function (newVal) {
      if (newVal === true) {
        this.requirdCusPriceMethod = true;
        this.rowData.IsWarranty = false;
        this.rowData.IsGiveUp = false;
      }
      this.requirdCusPriceTrue();
    },
    "rowData.IsGiveUp": function (newVal) {
      if (newVal === true) {
        this.requirdCusPriceMethod = false;
        this.rowData.IsAgreePrice = false;
        this.rowData.IsWarranty = false;
      }
      this.requirdCusPriceTrue();
    },
  },

  updated() {
    const keys = Object.keys(this.conditionData);
    keys.forEach((item) => {
      this.conditionData[item] = null;
    });
  },
  mounted() {
    this.getPinPData();
  },
  methods: {
    // 获取品牌名称数据
    async getPinPData() {
      let {
        data: { list },
      } = await tableApi.BrandSelect();

      this.options.pinP = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlePinP(v) {
      this.options.chanPType = [];
      this.options.chanPNum = [];
      this.conditionData.ProductId = "";
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.ProductSelect({ Bid: v });
      this.options.chanPType = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlechanPType(v) {
      this.options.chanPNum = [];
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.modelSelect({ ProductCategoryId: v });
      this.options.chanPNum = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    // rowData.FactoryBack_Id
    rowDataNull(v) {
      // let v == 0 ? null : v
      return v;
    },
    handDialogClose() {
      this.loadShow = false;
      this.activeName = "second";
    },
    //货运
    async selectDataComp() {
      let source = await tableApi.TransComp();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      // debugger;
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async BackFactory() {
      let source = await tableApi.BackFactory();
      if (source.code == 0) {
        let data = source.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildMoid == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 客户付款方式
    async CusPayType() {
      let source = await tableApi.CusPayType();

      if (source.code == 0) {
        let data = source.data.list.map(({ CusPayMethod_Id, Name }) => {
          return {
            label: Name,
            value: CusPayMethod_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 客户报价方式
    async CusPriceType() {
      let source = await tableApi.CusPriceType();
      if (source.code == 0) {
        let data = source.data.list.map(({ CusPriceMethod_Id, Name }) => {
          return {
            label: Name,
            value: CusPriceMethod_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 维修级别
    async LevelSearchs() {
      let source = await tableApi.LevelSearchs();
      if (source.code == 0) {
        let data = source.data.list.map(({ Level_Id, Name }) => {
          return {
            label: Name,
            value: Level_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    delSingleUser({ row }) {
      let id = row.Id;
      RepairProductCancel({ id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    //弹层事件
    // popConfirmButtonClick({
    // 	slotData
    // }) {

    // },
    customerRowDblClick(row) {
      switch (row.State_Id) {
        case 10:
          this.tabs.second = false;
          this.tabs.first = false;
          this.tabs.three = true;
          this.tabs.fourth = true;
          break;

        case 8:
          this.tabs.second = false;
          this.tabs.first = true;
          this.tabs.three = false;
          this.tabs.fourth = false;
          break;

        case 16:
          this.tabs.second = false;
          this.tabs.first = true;
          this.tabs.three = true;
          this.tabs.fourth = false;
          break;

        case 6:
          this.tabs.second = false;
          this.tabs.first = false;
          this.tabs.three = true;
          this.tabs.fourth = false;
          break;
        default:
          break;
      }
      this.loadShow = true;
      this.CustomerList.sn = row.SerialNoName;
      this.CustomerList.flag = 1;
      this.rowData = row;
      console.log(this.rowData, "aaaaaaa");
    },
    openPrint(row) {
      // this.loadShow = true
      // this.printBox = true
      console.log(row);
      successMsg("开发中");
    },
    requirdCusPriceTrue() {
      let { IsWarranty, IsAgreePrice, IsGiveUp } = this.rowData;
      if (IsWarranty == false && IsAgreePrice == false && IsGiveUp == false) {
        //CusPrice
        this.requirdCusPrice = true;
      } else {
        this.requirdCusPrice = false;
      }
    },
    saveBtn() {
      let {
        Id,
        IsWarranty,
        Level_Id,
        App1,
        App3,
        App2,
        App4,
        CusPrice,
        CusPayMethod_Id,
        CusPriceMethod_Id,
        IsAgreePrice,
        IsGiveUp,
      } = this.rowData;
      //requirdCusPrice
      // rowData.IsWarranty
      // rowData.IsAgreePrice
      // rowData.IsGiveUp
      if (Level_Id === null || Level_Id == 0) {
        return errMsg("请选择维修级别");
      }

      if (IsWarranty == false && IsAgreePrice == false && IsGiveUp == false) {
        //CusPrice
        if (CusPrice == 0) {
          return errMsg("给客户报价不能为0");
        }
      }

      console.log("this.CusPriceMethod-", this.CusPriceMethod);

      if (this.requirdCusPriceMethod == true) {
        if (CusPriceMethod_Id === null || CusPriceMethod_Id == 0) {
          return errMsg("请选择客户报价方式");
        }
        if (CusPayMethod_Id === null || CusPayMethod_Id == 0) {
          return errMsg("请选择客户付款方式");
        }
      }
      console.log("a-rowData:", this.rowData);
      MoneySave({
        Id,
        IsWarranty,
        Level_Id,
        App1: App1 == null ? 0 : App1,
        App3: App3 == null ? 0 : App3,
        App2: App2 == null ? 0 : App2,
        App4: App4 == null ? 0 : App4,
        CusPrice: CusPrice == null ? 0 : CusPrice,
        CusPayMethod_Id,
        CusPriceMethod_Id,
        IsAgreePrice,
        IsGiveUp,
      }).then((data) => {
        if (data.code == 0) {
          this.activeName = "second";
          successMsg(data.message);
          this.loadShow = false;
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    //维修保存
    repairSaveBtn() {
      let InternalRepairMethod = this.rowData.InternalRepairMethod;
      if (InternalRepairMethod === null) {
        return errMsg("维修方法不空");
      }
      let RepairMethod = JSON.stringify(this.rowData);
      RepairSave({ data: RepairMethod }).then((data) => {
        if (data.code == 0) {
          this.activeName = "second";
          successMsg(data.message);
          this.loadShow = false;
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    // 返厂维修保存
    returnRepairSaveBtn() {
      const FactoryBack = this.rowData;
      if (
        FactoryBack.FactoryBack_Id === null ||
        FactoryBack.FactoryBack_Id == 0
      ) {
        return errMsg("请选择返厂名称");
      }
      // 返厂RMA
      if (FactoryBack.MotoRMA === null || FactoryBack.MotoRMA == "") {
        return errMsg("请输入返厂RMA");
      }
      // 货运公司
      if (FactoryBack.TranComp_Id === null || FactoryBack.TranComp_Id == 0) {
        return errMsg("请选择货运公司");
      }
      //货运单号
      if (FactoryBack.TransferNo === null || FactoryBack.TransferNo == "") {
        return errMsg("请输入货运单号");
      }
      // 寄送时间
      if (FactoryBack.ReFacDate === null || FactoryBack.ReFacDate == "") {
        return errMsg("请选择寄送时间");
      }
      let backData = JSON.stringify(FactoryBack);
      BackFactorySave({ data: backData }).then((data) => {
        if (data.code == 0) {
          this.activeName = "second";
          this.loadShow = false;
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
      AddRetRma({ data: backData }).then((data) => {
        if (data.code == 0) {
          this.activeName = "second";
          this.loadShow = false;
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  #loadBOX {
    width: 100%;
    height: 100%;

    .text-field-container {
      display: flex;
    }

    .label-container {
      display: flex;
      width: fit-content;
      height: fit-content;
      padding: 10px;
      box-sizing: border-box;
    }
  }

  .pop-dialog-conver {
    background: yellow;
  }

  .oprationTree {
    background-color: #ecf5ff;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 25px 20px 15px 20px;

    .detailed-box {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #99bce8;
      background-color: #f4f7f6;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .detailed-title {
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 10px 20px;
        width: 320px;
      }

      .tabsThree-input {
        width: 700px !important;
      }

      .user-management-container .condition-container-input {
        margin: 5px 10px;
      }

      .checkboxM {
        margin: 0 20px 0 10px;
      }

      .checkbox-box {
        margin-top: 13px;
        margin-right: 20px;

        label {
          padding-right: 5px;
        }
      }

      .pop-dialogClose {
        position: absolute;
        top: 20px;
        right: 15px;

        .el-icon-close:before {
          font-size: 28px;
        }

        .el-icon-close:hover {
          color: #f92323;
        }
      }
    }
  }

  .pop-dialog-conver {
    display: block !important;
    width: 100% !important;
    height: 100% !important;
  }

  .control-button-container {
    margin: 25px auto;
    color: #409eff;
  }

  .el-radio {
    display: flex;
    width: 300px;
    justify-content: space-evenly;
    flex-direction: row-reverse;
    padding: 20px 20px;
  }

  .el-radio-group {
    width: 100%;
    display: inherit;
    font-family: hanSan !important;
    font-size: 20px;
  }

  // ::v-deep .el-checkbox{
  // 	color: red;
  // }

  .el-header,
  .el-footer {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  .el-iconBtn {
    // i{
    // 	font-size: 30px;
    // 	&:hover{
    // 		cursor:pointer
    // 	}
    // }
    &:hover {
      cursor: pointer;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }

  ::v-deep .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }
}

::v-deep .pop-dialog-container {
  transform: none !important;
}
</style>
